import { SignOutIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { useAuthContext } from "@/auth/auth-context";
import * as auth0 from "@/auth/auth0";
import { useSubscription } from "@/auth/subscription-context";
import { env, toggleProd } from "@/env/env";
import { Button } from "@/ui/button";
import {
  Menubar,
  MenubarContent,
  MenubarLabel,
  MenubarMenu,
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarTrigger,
} from "@/ui/menubar";

import { AdcUserAvatar } from "../user";
import { AdcCompanySearch } from "./adc-company-search";

const avatar = (fullName: string, email: string) => (
  <AdcUserAvatar name={fullName} email={email} role="User" />
);

export const AdcAppHeader = () => {
  const { fullName = "", email = "" } = useAuthContext();
  const { hasAdc, isLoading } = useSubscription();
  const { BACKEND, SHOW_BACKEND_SELECT } = env();

  const switchBackend = (value: string) => {
    toggleProd(value === "production");
    window.location.reload();
  };

  return (
    <header className="h-[80px] bg-blue-950 flex items-center justify-between gap-4 px-4">
      <Link
        to="/"
        className="flex items-center gap-3 text-white text-decoration-none"
      >
        <img src="/icons/icon-48x48.png" alt="" width={48} height={48} />
        <div className="flex flex-col max-md:hidden">
          <h1>Alt Data Consensus</h1>
          <small>by BattleFin</small>
        </div>
      </Link>
      {!isLoading && hasAdc && (
        <div className="flex-1 flex justify-center max-w-600px">
          <AdcCompanySearch />
        </div>
      )}
      <div className="flex items-center gap-4 text-white">
        {SHOW_BACKEND_SELECT ? (
          <Menubar className="border-none bg-transparent shadow-none p-0">
            <MenubarMenu>
              <MenubarTrigger
                aria-label="User menu"
                className="cursor-pointer text-white focus:bg-white/10 data-[state=open]:bg-white/10"
              >
                {avatar(fullName, email)}
              </MenubarTrigger>
              <MenubarContent align="end">
                <MenubarLabel>Backend</MenubarLabel>
                <MenubarRadioGroup
                  value={BACKEND}
                  onValueChange={switchBackend}
                >
                  <MenubarRadioItem value="production">
                    Production
                  </MenubarRadioItem>
                  <MenubarRadioItem value="test">Test</MenubarRadioItem>
                </MenubarRadioGroup>
              </MenubarContent>
            </MenubarMenu>
          </Menubar>
        ) : (
          avatar(fullName, email)
        )}
        <Button onClick={() => auth0.logout()} size="icon-sm" variant="ghost">
          <SignOutIcon size={16} />
        </Button>
      </div>
    </header>
  );
};
